import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "new-status-event" as const;

export type NewStatusEventData = {
  eventId: string;
  isAccepted: boolean;
};
export type NewStatusEvent = AppEvent<typeof eventName, NewStatusEventData>;

export const isNewStatusEvent = (event: AnyAppEvent): event is NewStatusEvent =>
  event.name === eventName;

export { eventName as newStatusEvent };
